<template>
	<core-modal
		name="bulk-archive-modal"
		class="omapi-modal bulk-archive-modal"
		:clickToClose="!isBulkArchiving"
		:isConfirmation="true"
	>
		<modals-content>
			<form @submit.prevent="bulkArchive">
				<p>Are you sure you want to archive {{ bulk.length }} {{ makePlural('campaign', bulk.length) }}.</p>

				<section class="buttons">
					<core-loading-button
						class="bulk-archive-campaign"
						size="large"
						color="blue"
						:loading="isBulkArchiving"
						buttonType="submit"
						ref="toFocus"
					>
						Yes, I'm Sure
					</core-loading-button>
					<core-button
						size="large"
						@click.prevent="$modal.hide('bulk-archive-modal')"
						:disabled="isBulkArchiving"
					>
						Cancel
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { archive } from '@/campaigns/mixins/archive'
import { strings } from '@/campaigns/mixins/strings'

export default {
	mixins : [ archive, strings ],
}
</script>

<style lang="scss">
.bulk-archive-modal {

}
</style>
